import NotificationBar from './notification-bar.vue';

export default NotificationBar;
